/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const matchingPageStyles = {
  displayFlex: css({
    display: 'flex',
  }),

  filterContainer: css({
    display: 'flex',
    marginLeft: '17px',
  }),

  title: css({
    flex: 5,
    textAlign: 'left',
    color: '#000',
    fontFamily: 'Pretendard',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: '-0.38px',
    marginLeft: '26px',
    marginBottom: '0px',
    marginTop: '70px',
  }),

  filterTimeBox: css({
    marginLeft: 'auto',
    marginRight: '18px',
    display: 'flex',
    alignItems: 'center',
  }),

  filterText: css({
    display: 'inline-flex',
    alignItems: 'center',
    color: 'var(--grey-04, var(--grey-04, #959DB1))',
    textAlign: 'center',
    fontFamily: 'Pretendard',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    letterSpacing: '-0.247px',
  }),

  searchIcon: css({
    flex: 1,
    marginTop: '70px',
    '& > img': {
      width: '27px',
      marginRight: '16px',
      marginLeft: '10px',
    },
  }),

  matchingList: css({
    marginBottom: '80px',
    marginInline: '17px',
  }),

  writeButton: css({
    position: 'fixed',
    bottom: '111px',
    right: '16px',
    zIndex: 999,
  }),
};

export const SerachPageStyles = {
  container: css({
    marginLeft: '16px',
  }),
  TopBar: css({
    display: 'flex',
    height: '56px',
    marginTop: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  SearchBar: css({
    borderRadius: '6px',
    width: '100%',
    height: '47px',
    border: '#FAFAFB',
    paddingLeft: '20px',
    marginTop: '3px',
    outline: 'none',
    transition: 'border-color 0.3s ease-in-out',
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Pretendard',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '150%',
    letterSpacing: '-0.304px',
  }),
  PopularContainer: css({
    display: 'flex',
    flexWrap: 'wrap',
  }),
  PopularButton: css({
    display: 'flex',
    height: '34px',
    padding: '7px 18px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
    borderRadius: '16.5px',
    border: '1px solid var(--main-01, #0074FF)',
    background: '#FFF',
    color: 'var(--main-01, #0074FF)',
    textAlign: 'center',
    fontFamily: 'Pretendard',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: '-0.266px',
    marginRight: '8px',
    marginTop: '14px',
  }),
  RecentContainer: css({
    display: 'flex',
    justifyContent: 'space-between',
  }),
  RecentKeyWordContaniner: css({
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '25px',
  }),
  RecentBar: css({
    width: '46%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '12px',
    marginBottom: '8px',
    '& > div': {
      color: 'var(--grey-04, var(--grey-04, #959DB1))',
      fontWeight: 500,
      fontFamily: 'Pretendard',
      fontSize: '16px',
      fontStyle: 'normal',
      lineHeight: '150%',
      letterSpacing: '-0.304px',
    },
  }),
  PopularText: css({
    color: 'var(--grey-03, var(--grey-03, #676F83))',
    fontWeight: 600,
    fontFamily: 'Pretendard',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '150%',
    letterSpacing: '-0.304px',
    marginTop: '25px',
  }),
  RecentText: css({
    color: 'var(--grey-03, var(--grey-03, #676F83))',
    fontWeight: 600,
    fontFamily: 'Pretendard',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '150%',
    letterSpacing: '-0.304px',
    marginTop: '32px',
  }),
  ClearText: css({
    color: 'var(--grey-04, var(--grey-04, #959DB1))',
    fontFamily: 'Pretendard',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    letterSpacing: '-0.266px',
    marginTop: '32px',
    marginRight: '16px',
  }),
};

export const matchingRequestStyles = {
  container: css({
    marginInline: '17px',
    '& > div': {
      marginTop: '31px',
    },
  }),
  title: css({
    color: 'var(--grey-01, var(--grey-01, #202123))',
    fontFamily: 'Pretendard',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: '-0.38px',
  }),
  explain: css({
    color: 'var(--grey-03, var(--grey-03, #676F83))',
    fontFamily: 'Pretendard',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '150%',
    letterSpacing: '-0.304px',
  }),
  requestContainer: css({
    height: '152px',
    borderRadius: '8px',
    border: '1px solid var(--grey-06, #E5E9EF)',
    background: 'var(--grey-08, #FAFAFB)',
    marginBottom: '17px',
  }),
  requestContainer2: css({
    height: '152px',
    borderRadius: '8px',
    border: '1px solid var(--grey-06, #676F83)',
    background: 'var(--grey-08, #FAFAFB)',
    marginBottom: '17px',
  }),
  profile: css({
    width: '60px',
    height: '60px',
    flexShrink: '0px',
    marginTop: '22.5px',
    marginLeft: '15.71px',
    '& > img': {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
    },
  }),
  username: css({
    color: '#202123',
    fontFamily: 'Pretendard',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: '-0.285px',
    marginTop: '2px',
    marginBottom: '0px',
    marginRight: '10.38px',
  }),
  userInfo: css({
    color: 'var(--grey-03, var(--grey-03, #676F83))',
    fontFamily: 'Pretendard',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '150%',
    letterSpacing: '-0.266px',
  }),
  uesrmsg: css({
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
    '& > span': {
      color: 'var(--grey-03, var(--grey-03, #676F83))',
      fontFamily: 'Pretendard',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: '-0.266px',
    },
  }),
  lookuser: css({
    height: '29px',
    width: '90px',
    padding: '4px 12px',
    marginTop: '34px',
    marginLeft: '20.76px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '19.35px',
    border: '1px solid var(--grey-04, #959DB1)',
    '& > span': {
      color: 'var(--grey-04, var(--grey-04, #959DB1))',
      textAlign: 'center',
      fontFamily: 'Pretendard',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: '-0.266px',
    },
  }),
  message: css({
    height: '29px',
    width: '90px',
    padding: '4px 12px',
    marginTop: '34px',
    marginLeft: '20.76px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '19.35px',
    border: '1px solid var(--grey-04, #0066FF)',
    '& > span': {
      color: 'var(--grey-04, var(--grey-04, #0066FF))',
      textAlign: 'center',
      fontFamily: 'Pretendard',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: '-0.266px',
    },
  }),
  button: css({
    display: 'flex',
    marginTop: '17px',
    marginInline: '15px',
    '& > div': {
      display: 'flex',
      height: '39px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      flexShrink: 0,
      borderRadius: '6px',
      '& > span': {
        color: '#FFFFFF',
        textAlign: 'center',
        fontFamily: 'Pretendard',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '150%',
        letterSpacing: '-0.266px',
      },
    },
  }),
  flexBox: css({
    display: 'flex',
    flexDirection: 'row',
  }),
  inforBox: css({
    marginLeft: '17px',
    paddingTop: '27.82px',
  }),
  rejectButton: css({
    flex: '1',
    background: 'var(--grey-02, #333B4F)',
    marginRight: '12px',
  }),
  rejectButton2: css({
    flex: '1',
    background: '#CACFD9',
    marginRight: '12px',
  }),
  applyButton: css({
    flex: '2',
    background: '#0066FF',
  }),
  applyButton2: css({
    flex: '2',
    background: '#CACFD9',
  }),
};
